export default "__VITE_PUBLIC_ASSET__c76b2b47__"